import MomentUtils from '@date-io/moment';
import { IconButton } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { configure } from 'mobx';
import 'mobx-react-lite/batchingForReactDom';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';
import 'react-app-polyfill/stable';
import { render } from 'react-dom';
import { Mainpanel } from './mainpanel/Mainpanel';
import { toasterSvc } from './services/ToasterSvc';
import { serviceWorkerLoader } from './ServiceWorkerLoader';
import { getOmnistore, OmnistoreProvider } from './stores/Omnistore';
import { Workarounds } from './Workarounds';

configure({enforceActions: 'observed'});

Workarounds.fixChromeEvents();

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#10069F',
		},
		secondary: {
			main: '#CE0058',
		},
	},
	typography: {
		fontFamily: '"TT Hoves", "Roboto", "Helvetica", "Arial", sans-serif',
	},
});
(theme.palette as any).special = {
	main: '#4CAF50',
};

const toast = (key: string) => <IconButton onClick={() => {toasterSvc.hide(key);}} aria-label="Close" color="inherit"><CloseIcon/></IconButton>;

render(<OmnistoreProvider>
	<MuiThemeProvider theme={theme}>
		<SnackbarProvider maxSnack={7} action={toast}>
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<Mainpanel />
			</MuiPickersUtilsProvider>
		</SnackbarProvider>
	</MuiThemeProvider>
</OmnistoreProvider>,
document.getElementById('root'));

const reoctoStore = getOmnistore().reoctoStore;

if (reoctoStore.useServiceWorkerLoader) {
	serviceWorkerLoader.register({});
} else {
	serviceWorkerLoader.unregister();
}
